import React from 'react'
import ExpandablePanel from '../controls/ExpandablePanel'
import TextField from '@material-ui/core/TextField'
import { controlHasError } from '../../lib/errorHandler'
import PrintText from '../../lib/PrintText'

export default function MetodyAmortyzacji(props) {
  return (
    <ExpandablePanel title="METODY DOKONYWANIA AMORTYZACJI">
      <form autoComplete="off" className="subsection">
        {props.czyPodsumowanie ? (
          <PrintText
            text={props.data.MetodyAmortyzacji}
          />
        ) : (
          <TextField
            error={controlHasError(
              props.errors,
              'MetodyAmortyzacji',
              props.data.MetodyAmortyzacji,
            )}
            name="MetodyAmortyzacji"
            label="Opis"
            multiline
            variant="outlined"
            title={props.data.MetodyAmortyzacji}
            defaultValue={props.data.MetodyAmortyzacji}
            onBlur={(e) =>
              props.onSetSectionData('MetodyAmortyzacji', e.target.value)
            }
          />
        )}
      </form>
    </ExpandablePanel>
  )
}
